export default str =>
  typeof str === 'string' ? str[0].toUpperCase() + str.substr(1) : str
